import { GET_ALL_PAGE_CONTENT, GET_PAGE_CONTENT_BY_TYPE, GET_SYTSEM_SETTINGS_LIST, UPDATE_PAGE_CONTENT_BY_TYPE, UPDATE_SYTSEM_SETTINGS } from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";


const { reducer, actions, thunks } = createCrudSlice({
  name: "page contents",


  initialFilters: {
    keyword: "",
    status: -1,
    orderBy: -1,
    dates: [],
    pageNo: 1,
    perPage: 50,
    platform :""
  },
    urls: {},

  additionalThunks: {
    getAllPageContents: {
      type: "pagecontetns/getAllPageContents",
      url: () => `${GET_ALL_PAGE_CONTENT}`,
      method: "post",
      stateKey: "pageContents",
      // loadingKey: "loading2",
    },
    getPageContentByType: {
      type: "pagecontetns/getPageContentByType",
      url: () => `${GET_PAGE_CONTENT_BY_TYPE}`,
      method: "post",
      stateKey: "data",
      // loadingKey: "loading2",
    },
    updatePageContentByType: {
      type: "pagecontetns/updatePageContentByType",
      url: () => `${UPDATE_PAGE_CONTENT_BY_TYPE}`,
      method: "put",
      stateKey: "pageContents",
      // loadingKey: "loading2",
    },
    getSystemSettings: {
      type: "settings/getSystemSettings",
      url: () => `${GET_SYTSEM_SETTINGS_LIST}`,
      method: "get",
      stateKey: "systemSettings",
      loadingKey: "loading2",
    },
    updateSystemSettings: {
      type: "settings/updateSystemSettings",
      url: () => `${UPDATE_SYTSEM_SETTINGS}`,
      method: "put",
      stateKey: "systemSettings",
      loadingKey: "loading2",
    },
  },

  initialState: {
    loading2: true,
    vehicleDetails: [],
    pageContents: [],
    data : [],
    systemSettings :[],
    
  },
});

// Export actions
export const { setFilter, resetFilters, clearItemDetails } = actions;

// Export thunks
export const {
  getAllPageContents,
  getPageContentByType,
  updatePageContentByType,
  getSystemSettings,
  updateSystemSettings
} = thunks;

// Export reducer
export default reducer;
